import styled from 'styled-components';
import { showAnimation } from '../commons/showAnimation';
export var Card = styled.div.withConfig({
  displayName: "Card",
  componentId: "sc-12gcvzc-0"
})(["position:absolute;z-index:2;", ";", ";opacity:1;width:330px;text-align:left;", ";"], function (_ref) {
  var posX = _ref.posX;
  return posX === 'top' ? 'bottom: 100%' : 'top: 100%;';
}, function (_ref2) {
  var posY = _ref2.posY;
  return posY === 'right' ? 'right: 0;' : posY === 'center' ? 'left: 50%; margin-left: -165px;' : 'left: 0;';
}, showAnimation);